import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PreviousPage } from '@rivethealth/data/breadcrumb';

@Component({
  selector: 'back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  @Input()
  pageTitle: string = '';

  @Input()
  previousPages: PreviousPage[] = [];

  @Input()
  customBackButtonTitle: string | undefined;

  @Output()
  backButtonClick = new EventEmitter();

  constructor() {}

  get lastPage(): PreviousPage | undefined {
    return this.previousPages[this.previousPages.length - 1];
  }
}
